import React from 'react'
import PropTypes from 'prop-types'
// const ArticleSmall = dynamic(() => import('@shared/components/article/articleSmall'))
import ArticleSmall from '../common/articleSmall'
import useWindowSize from '@shared/hooks/windowSize'
// import ArticleSmall from '@shared/components/article/articleSmall'
function TrendingNewsContent({ data, imgCol, isMobile = false }) {
  const [width] = useWindowSize()
  return (
    <>
      {data?.map((news, index) => {
        return <ArticleSmall isMobile={isMobile} data={news} key={news._id} hideBadge isLarge={width > 992} />
      })}
    </>
  )
}
TrendingNewsContent.propTypes = {
  data: PropTypes.array,
  imgCol: PropTypes.number,
  isMobile: PropTypes.bool
}

export default TrendingNewsContent
